import type { FaireProductEntity } from "../../entity_types/product";

export const p_j9x8z54bgt: FaireProductEntity = {
  token: "p_j9x8z54bgt",
  type: "product",
  name: "Magnesium Bath Bomb",
  brandToken: "b_ftqh3zqnue",
  brandName: "Nature's Love Product",
  imageUrl:
    "https://cdn.faire.com/fastly/1ed5ed0cff3abf5634b03eb9c7a5a1dda77d190d20c9a9330b77f49d0309871f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9860605fdf1979fcafefc3d9a0cd5fb292dfe5a59095bf28b72354ac992a4e37.jpeg",
    "https://cdn.faire.com/fastly/501e45f300b32754481c363006a28c6b3c2b901c383d66a57fbffbdd811b84cc.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "There are many ways to get enough magnesium these days. By capsule, cream, lotion, oil and now let's add bath bombs to the awesome mix. Our bath bombs are made with two types of magnesium chloride and nano magnesium. Both are incredible for the body and help aid in relaxation and sleep. Nature's Love Product bath bombs are made by small batch to ensure the quality of each bath bomb. \n\nWhat are some of the benefits Magnesium may help? \n-headaches\n-menstrual cramps\n-sore muscles\n-growing pains/restless legs\n-pregnancy aches and pains in legs (please consult doctor before using)\n-digestion issues\n-arthritis \n-sprains\n-inflammation\n\nIngredients: Epsom salt, citric acid, baking soda, arrowroot, witch hazel, shea butter, grapseed oil, magnesium flakes, nano magnesium, Himalayan salt, lavender turmeric.\n\n  Nature's Love Product is not evaluated by the FDA and does not claim to give medical advice Please consult doctor if you have health concerns.   \n",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:53.342Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
